export default "<div class=\"editorial_contenu\">\n  <p [innerHtml]=\"'ERROR.NO_URL_DEST_PARAM' | translate\"></p>\n</div>\n";